import BaseRepository from "./BaseRepository";
import BOMAPICall from "../service/BOMAPICall";
import ProductRepository from "./ProductRepository";
import QuoteRepository from "./OpenQuoteRepository";
import produceClone from "../helper/produceClone";
import { SET_BULK_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT } from "../store/slice/model/Cart";
import { UPDATE_BomfarnellData } from "../store/slice/model/BOM";
import store from "src/storeWire";

class BOMRepository extends BaseRepository {
    /**
     * Send ERPMFRPartNumber for used as partNumber
     * Author: Devanshi Patel
     */
    createBOM = async (params) => {
        return await new BOMAPICall().createBOM(params);
    };
    createBlankBOM = async () => {
        let params = {
            bomName: '', ERPPartNumber: '', quantity: 0, fromCart: false,
            ManufacturerPartNumber: false, ItemNumber: false, LifeCycleRisk: '', bomRequest: '-',
            CUSTOMER_PART_NUMBER: false, ERPMFRPartNumber: false
        }
        return await this.createBOM(params);
    };
    fetchBOMList = async () => {
        return await new BOMAPICall().fetchBOMList();
    };
    fetchProductCategoryList = async () => {
        return await new BOMAPICall().fetchProductCategoryList();
    };
    editBOMName = async (bomName, bomId) => {
        return await new BOMAPICall().editBOM({
            bomName,
            bomId
        });
    };
    setBOMIsRematchFlag = async (bomId) => {
        return await new BOMAPICall().setBOMIsRematchFlag({
            bomId
        });
    };
    addPartToBOM = async (params) => {
        return await new BOMAPICall().addPartToBOM(params);
    };
    getBomDetailByBomID = async (bomId) => {
        return await new BOMAPICall().getBomDetailByBomID({ bomId });
    };
    deleteBOMByBomID = async (bomId) => {
        return await new BOMAPICall().deleteBOMByBomID({ bomId });
    };
    copyBOMByBomID = async (params) => {
        return await new BOMAPICall().copyBOMByBomID(params);
    };
    getBomHealthByBomID = async (bomId) => {
        let bomHealthRes = await new BOMAPICall().getBomHealthByBomID({ bomId });
        let healthResult = []
        if (bomHealthRes !== undefined && bomHealthRes.length > 0) {
            let totalCount = 0;
            bomHealthRes.map((v, i) => {

                if (i === 1) {
                    totalCount = v.percentage.split('/')[1]
                }
                if (v.lifeCycleRisk !== undefined && v.lifeCycleRisk !== '') {
                    let healthResultObj = {}
                    healthResultObj.lifeCycleRisk = v.lifeCycleRisk.toLowerCase() === 'low' ? 'low'
                        : v.lifeCycleRisk.toLowerCase() === 'high' ? 'high'
                            : v.lifeCycleRisk.toLowerCase() === 'med' ? 'med' : 'unknown'
                    healthResultObj.percentage = v.percentage !== undefined ? v.percentage : 0

                    if (healthResultObj.lifeCycleRisk === 'low') {
                        healthResult.splice(0, 0, healthResultObj);
                    } else if (healthResultObj.lifeCycleRisk === 'med') {
                        healthResult.splice(1, 0, healthResultObj);
                    } else if (healthResultObj.lifeCycleRisk === 'high') {
                        healthResult.splice(2, 0, healthResultObj);
                    } else {
                        healthResult.splice(3, 0, healthResultObj);
                    }

                }
            })

            /**
             * Description: This is make for add 0% if not come from the backend for low , med, high
             * Author: Devanshi Patel
             */

            const lowFound = healthResult.some(el => el.lifeCycleRisk === 'low');
            if (!lowFound) {
                let zeroHealthObj = {}
                zeroHealthObj.lifeCycleRisk = 'low'
                zeroHealthObj.percentage = 0 + '/' + totalCount
                healthResult.splice(0, 0, zeroHealthObj);
            }

            const medFound = healthResult.some(el => el.lifeCycleRisk === 'med');
            if (!medFound) {
                let zeroHealthObj = {}
                zeroHealthObj.lifeCycleRisk = 'med'
                zeroHealthObj.percentage = 0 + '/' + totalCount
                healthResult.splice(1, 0, zeroHealthObj);
            }

            const highFound = healthResult.some(el => el.lifeCycleRisk === 'high');
            if (!highFound) {
                let zeroHealthObj = {}
                zeroHealthObj.lifeCycleRisk = 'high'
                zeroHealthObj.percentage = 0 + '/' + totalCount
                healthResult.splice(2, 0, zeroHealthObj);
            }

            const unknownFound = healthResult.some(el => el.lifeCycleRisk === 'unknown');
            if (!unknownFound) {
                let zeroHealthObj = {}
                zeroHealthObj.lifeCycleRisk = 'unknown'
                zeroHealthObj.percentage = 0 + '/' + totalCount
                healthResult.splice(3, 0, zeroHealthObj);
            }
        }
        return healthResult
    };
    bomDownloadFile = async (bomId, fileType, fieldColumns, currentCurrency) => {
        return await new BOMAPICall().bomDownloadFile({
            bomId,
            fileType,
            fieldColumns,
            currentCurrency
        });
    };
    bomEmailFile = async (bomId, fileType, fieldColumns, recipientEmail, senderEmail, message, currentCurrency) => {
        return await new BOMAPICall().bomEmailFile({
            bomId,
            fileType,
            fieldColumns,
            recipientEmail,
            senderEmail,
            message,
            currentCurrency
        });
    };
    saveDownloadFilePreference = async (content = {}) => {
        if (content?.prefType) {
            return await new BOMAPICall().saveDownloadFilePreference(content);
        }
        return await new BOMAPICall().saveDownloadFilePreference({
            preferenceValue: JSON.stringify(content)
        });
    };
    fetchDownloadFilePreference = async (params = {}) => {
        return await new BOMAPICall().fetchDownloadFilePreference(params);
    };

    getBomDetailByBomIDWithType = async (bomId, matchType, sortColumn, sortOrder, isReRunPartMatch = false, top = 10, force_all_skip_redux_check = false, callFrom = '', skip = '') => {
        let res = await new BOMAPICall().getBomDetailByBomIDWithType({
            bomId,
            matchType,
            isReRunPartMatch,
            top,
            force_all_skip_redux_check,
            sortColumn, sortOrder, //10889
            skip
        });
        if (res.data.Exact.records) {
            let BULK_CART_CUSTOMER_PART_NUMBER_ARRAY = [];
            await Promise.all(Object.entries(res.data.Exact.records).map(async value => {
                if (value[1].customerPartNumber && value[1].itemNumber) {
                    BULK_CART_CUSTOMER_PART_NUMBER_ARRAY.push({
                        ItemNumber: value[1].itemNumber,
                        CUSTOMER_PART_NUMBER: value[1].customerPartNumber,
                    })
                }
            }));

            if (BULK_CART_CUSTOMER_PART_NUMBER_ARRAY.length > 0) {
                store.dispatch(SET_BULK_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT({
                    CART_DATA: BULK_CART_CUSTOMER_PART_NUMBER_ARRAY
                }));
            }
            let forceCall = (matchType.toLowerCase() === 'exact')
            if (callFrom !== 'Download') {
                let p_res = await new ProductRepository().attachProductAndInventoryToAnyObjectNew(res.data.Exact.records, forceCall, false);
                res.data.Exact.records = produceClone(p_res);
                p_res = await new BOMAPICall().attachBOMAlternativeToBOMDetailAPICall(res.data.Exact.records);
                res.data.Exact.records = produceClone(p_res);
            }

            if (Object.entries(res.data.Exact.records).length > 0) {
                let BULK_CART_CUSTOMER_PART_NUMBER_ARRAY = [];
                Object.entries(res.data.Exact.records).map(async value => {
                });
            }
        }
        return res;
    };

    cartValid = (bomData, price, inventory) => {
        let cartValidStatus = true
        let validResult = {}
        if (bomData.product !== undefined && bomData.quantity >= bomData.product.QtyMin && bomData.quantity % bomData.product.QtyMult === 0) {
            validResult.isCartValidQty = true
            validResult.isCartValid = true
        } else {
            validResult.isCartValidQty = false
            validResult.isCartValid = false
            cartValidStatus = false
        }

        if (cartValidStatus === true) {
            if (price && Object.keys(price).length <= 0) {
                validResult.isCartValid = false
            } else if (inventory && price && inventory?.quantity > 0 && Object.keys(price).length > 0) {

                validResult.isCartValid = true
            } else if (inventory && price && inventory?.quantity <= 0 && Object.keys(price).length > 0) {

                validResult.isCartValid = true
            } else {
                validResult.isCartValidQty = false
                validResult.isCartValid = false
            }
        }
        return validResult
    }

    quoteValid = (bomData) => {
        let validResult = {};
        // DT - 31/3 - Obsolete - click to Quote willbe disabled
        if (bomData.product && bomData.product.ObsoleteFlag === true)
            validResult.isQuoteValid = false;
        else
            validResult.isQuoteValid = true;
        return validResult
    }

    getMinPriceBySpeedBoat = async () => {
        return await new QuoteRepository().getQuoteMinPriceBySpeedBoat()
    }

    getBomDetailCountByBomID = async (bomId) => {
        let res = await new BOMAPICall().getBomDetailByBomIDWithType({
            bomId,
            matchType: 'NoMatch',
            isReRunPartMatch: false,
            top: 1,
            force_all_skip_redux_check: false
        });
        let final_res = {};
        if (res.data !== null && res.data !== undefined) {
            // Exact Match
            if (res.data.Exact !== undefined && res.data.Exact !== null &&
                res.data.Exact.count !== undefined && res.data.Exact.count !== null &&
                res.data.Exact.count > -1) {
                final_res.Exact = {
                    count: res.data.Exact.count
                };
            }

            // Multiple
            if (res.data.Multiple !== undefined && res.data.Multiple !== null &&
                res.data.Multiple.count !== undefined && res.data.Multiple.count !== null &&
                res.data.Multiple.count > -1) {
                final_res.Multiple = {
                    count: res.data.Multiple.count
                };
            }

            // No Match
            if (res.data.NoMatch !== undefined && res.data.NoMatch !== null &&
                res.data.NoMatch.count !== undefined && res.data.NoMatch.count !== null &&
                res.data.NoMatch.count > -1) {
                final_res.NoMatch = {
                    count: res.data.NoMatch.count
                };
            }

            // UnMatch
            if (res.data.UnMatch !== undefined && res.data.UnMatch !== null &&
                res.data.UnMatch.count !== undefined && res.data.UnMatch.count !== null &&
                res.data.UnMatch.count > -1) {
                final_res.UnMatch = {
                    count: res.data.UnMatch.count
                };
            }
        }
        return final_res;
    };
    downloadBomTemplate = async () => {
        return await new BOMAPICall().downloadBomTemplate();
    };
    createPartList = async (params) => {
        return await new BOMAPICall().createPartList(params);
    };
    assignBOMToProject = async (bomId, projectId) => {
        return await new BOMAPICall().assignBOMToProject({
            bomId,
            projectId
        });
    };
    swapPartNumber = async (params) => {
        return await new BOMAPICall().swapPartNumber(params);
    };
    updateQuantityByBomDetailID = async (bomDetailId, quantity) => {
        return await new BOMAPICall().updateQuantityByBomDetailID({
            bomDetailId,
            quantity
        });
    };
    updateCustomerPartNumberByBomDetailID = async (params) => {
        return await new BOMAPICall().updateCustomerPartNumberByBomDetailID(params);
    };
    removePartNumber = async (bomDetailId, bomId) => {
        return await new BOMAPICall().removePartNumber({
            bomDetailId,
            bomId
        });
    };
    getMultipleMatchProductSearch = async (bomDetailId, getRawData = true) => {
        let res = await new BOMAPICall().getMultipleMatchProductSearch({
            bomDetailId
        });
        if (getRawData === true) {
            return res;
        }
        if (res.Products !== undefined) {
            return res.Products;
        }
    };
    getFarnellBomList = async (params) => {
        const result = await new BOMAPICall().getFarnellBomList(params);
        const filterCommonSku = {};
        if (result?.data?.manufacturerPartNumberSearchReturn?.products) {
 
            result.data.manufacturerPartNumberSearchReturn.products =
                result.data.manufacturerPartNumberSearchReturn.products.reduce((acc, v) => {
                    if (!filterCommonSku[v.sku]) {
                        filterCommonSku[v.sku] = true;
                        acc.push({
                            ...v,
                            translatedMinimumOrderQuality: 1,
                            qtyError: false
                        });
                    }
                    return acc;
                }, []);
        }
 
        return result;
    };
    

    updateFarnellQte = async (params = {}) => {
        console.log(params)
        store.dispatch(UPDATE_BomfarnellData({
            params
        }));
    };
}

export default BOMRepository;